import { useState, useEffect } from "react";
import { IoCloudDownloadOutline } from "react-icons/io5";

import Toaster from "./../../../components/common/Toaster";
import journalService from "./../../../services/journalService";

const columns = [{ label: "CUSTOMER" }, { label: "SC/PWD ID NO." }];

const ClientRegistry = ({ id }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        setIsLoading(true);

        const { result } =
          await journalService.getAccountClientRegistryReportAsync(id);

        if (mounted) {
          setData(result);
          setIsLoading(false);
        }
      } catch (ex) {
        setIsLoading(false);
        Toaster.Error("Something went wrong.");
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, [id]);

  const handleExport = async () => {
    try {
      const { result } = await journalService.generateClientRegistryAsync(id);

      const mediaType =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";

      const link = document.createElement("a");
      link.href = mediaType + result.content;
      link.download = result.file_name;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    }
  };

  return (
    <div className="card p-6">
      <div className="flex justify-end mb-2 px-5">
        <button
          className="button button-primary w-44 text-white"
          onClick={() => handleExport()}
        >
          <IoCloudDownloadOutline className="mr-2" /> Export to Excel
        </button>
      </div>
      {data && !isLoading && (
        <div className="p-4">
          <div className="mb-10 text-center">
            <p>Dr. {data.name}</p>
            <span className="font-bold text-sm">Client Registry</span>
          </div>
          <table className="min-w-full table-fixed">
            <thead>
              <tr className="border-t border-b border-black">
                {columns.map((item, index) => (
                  <th
                    key={index}
                    className="font-semibold text-sm py-1 px-4 text-left border-r border-gray-200 last:border-r-0"
                  >
                    {item.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.clients &&
                data.clients.map((item, index) => {
                  return (
                    <tr key={index} className="text-sm">
                      <td className="px-4 py-2">{item.client_name}</td>
                      <td className="px-4 py-2">{item.senior_number}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ClientRegistry;
